import { LoginScreen } from '../LoginScreen'
import { AppBootLoading } from '../components/AppBootLoading'
import { useAbp } from '../platform/abp/react'

/** Public login at `/login`. */
export function LoginRoute() {
  const { ready } = useAbp()

  if (!ready) {
    return <AppBootLoading label="Loading…" />
  }

  return <LoginScreen onSignedIn={() => undefined} />
}
